import { BodyRenderExternalData } from '~/components/BodyRender/models';
import { SalsifyColumnsTextProps } from '~/components/SalsifyColumnsText/models';
import { pageBlockUIMapper } from '~/mappers/pageBlock';
import { salsifyTextMapper } from '~/mappers/salsifyText';

import { SalsifyColumnsText } from './models';

export const salsifyColumnsTextMapper = (
  { salsifyTextColumns, pageBlockUI, componentId, uid }: SalsifyColumnsText,
  currentPageUid: string,
  { salsifyExternalData }: BodyRenderExternalData
): SalsifyColumnsTextProps => {
  if (!salsifyExternalData) {
    throw new Error('No salsify data');
  }

  return {
    salsifyTextColumns: salsifyTextColumns.map((column) =>
      salsifyTextMapper(column, currentPageUid, { salsifyExternalData })
    ),
    pageBlock: pageBlockUIMapper(pageBlockUI[0].ui),
    componentId,
    uid,
  } as SalsifyColumnsTextProps;
};
